module.exports = __webpack_public_path__ + "img/dots_pattern.2a155f4b.svg";